import { useTranslation } from 'react-i18next';
import { DoughnutChart } from 'src/common/components/Graphs/common/Graphs/DoughnutChart';
import { useProductsSummarySubscriptionStatusData } from './hooks/useProductsSummarySubscriptionStatusData';

type SubscriptionStatusChartProps = {
  tariffCode: string | null;
};

export const SubscriptionStatusChart = ({ tariffCode }: SubscriptionStatusChartProps) => {
  const { t } = useTranslation();
  const { chartData, total } = useProductsSummarySubscriptionStatusData({ tariffCode });

  return (
    <DoughnutChart
      data={chartData}
      total={total}
      aria-label={t('dashboard.subscriptionsStatusChart.title')}
    />
  );
};
